import { render } from "./ExplorePublications.vue?vue&type=template&id=08a2e0fc"
import script from "./ExplorePublications.vue?vue&type=script&lang=js"
export * from "./ExplorePublications.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"public/themes/default/resources/app/vue/components/AdvancedSearch/ExplorePublications.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "08a2e0fc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('08a2e0fc', __exports__)) {
    api.reload('08a2e0fc', __exports__)
  }
  
  module.hot.accept("./ExplorePublications.vue?vue&type=template&id=08a2e0fc", () => {
    api.rerender('08a2e0fc', render)
  })

}


export default __exports__